import { useMemo } from 'react'
import { CyclesPage } from './CyclesPage'
import { createCycleDashboardStore } from './stores/cycleDashboardStore'

export const CyclesPageContainer = () => {
	const store = useMemo(() => createCycleDashboardStore(), [])

	return <CyclesPage store={store} />
}
